import { render, staticRenderFns } from "./CaptureTrn.vue?vue&type=template&id=089c07be&scoped=true&"
import script from "./CaptureTrn.vue?vue&type=script&lang=ts&"
export * from "./CaptureTrn.vue?vue&type=script&lang=ts&"
import style0 from "./CaptureTrn.vue?vue&type=style&index=0&id=089c07be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089c07be",
  null
  
)

export default component.exports